import { createRoute } from "../../utils";

import { homeRoutesObj, homeBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const homeRouteMetadata: IRouteMetadataObj<typeof homeRoutesObj> = {
  home: {
    title: "mainPage",
    lazy: () => import("@/pages/commonPages/home/page"),
    mode: "index",
    permission: "all",
  },
};

export const homeRoutes = createRoute<typeof homeRoutesObj>(
  homeRoutesObj,
  homeRouteMetadata,
  homeBreadcrumbs,
);
